export const styleRowInputWrapper = `
    display:flex;
    flex-direction:row;
    align-items:center;
    label{
        width:150px;
    }

    @media(max-width:1024px){
        flex-direction:column;
        align-items:flex-start;
        label{
            width:auto;
        }
    }
`

export const styleRow = `
    justify-content:space-between;
    row-gap:15px;
    @media(max-width:800px){
        display:flex !important;
        flex-flow:row wrap;
    }
`
export const styleDropdownInput = `
    flex:1;
    @media(max-width:800px){
        flex:none;
    }
`
export const styleHalfWrapper = `
    width:48%;
    @media(max-width:800px){
        width:100%;
    }
`

export const styleDropdownOptionsWrapper = `
    @media(min-width:800px){
        top:50px;
        width:calc(100% - 150px);
        margin-left:150px;
    }
    @media(max-width:800px){
        width:100%;
        margin:0px;
    }
`
